/*
 *   File : profile.js
 *   Author : https://evoqins.com
 *   Description : Profile summary
 *   Version : 1.0.0
*/

import { Fragment, useState } from "react"
import TextButton from "../../../Components/Buttons/text-button";
import { useLocation } from "react-router-dom";

import APIService from "../../../Services/api-service";
import { toast } from "react-toastify";

const Profile = (props) => {
    const location = useLocation();
    const [downloadLoader, setDownloadLoader] = useState(false);
    const [uploadLoader, setUploadLoader] = useState(false);

    const _downloadForm = () => {
        setDownloadLoader(true);
        let url = '/user/download-proof';
        let payload = {
            user_id: location.state.id
        }
        APIService(true, url, payload).then((response) => {
            if (response.status_code === 200) {
                window.open(response.data?.url)
            } else {
                toast.error(response.message)
            }
            setDownloadLoader(false);
        })
    }

    const _uploadForm = () => {
        setUploadLoader(true)
        let url = '/user/upload-proof';
        let payload = {
            user_id: location.state.id
        }
        APIService(true, url, payload).then((response) => {
            if (response.status_code === 200) {
                toast.success("Successfully uploaded")
            } else {
                toast.error(response.message)
            }
            setUploadLoader(false);
        })

    }


    const ProfileInfo = ({ title, description }) => {
        return (
            <div className="col-lg-4 col-sm-6 col-12">
                <h6 className="e-font-14 e-line-height-18 e-montserrat-semi-bold color-gray mb-2">
                    {title}
                </h6>
                <p className="e-font-14 e-line-height-18 e-montserrat-medium color-dark-charcoal mb-0">
                    {description === null ? "-" : description}
                </p>
            </div>
        )
    }

    return (
        <Fragment>
            <div className="bg-white border-radius-24px padding-32px-all">

                {/* ===================Personal details ================*/}
                <div className="border-bottom-point5px border-color-mint-gray pb-4">
                    <h4 className="e-font-16 e-line-height-20 e-montserrat-semi-bold color-gunmetal-gray mb-3">Profile information</h4>

                    <div className="row row-gap-24px">
                        <ProfileInfo title="Name"
                            description={props.data.overview.name} />
                        <ProfileInfo title="DOB"
                            description={props.data.overview.dob} />
                        <ProfileInfo title="Gender"
                            description={props.data.overview.gender || "-"} />
                        <ProfileInfo title="PAN"
                            description={props.data.kyc.pan} />
                        <ProfileInfo title="Country"
                            description={props.data.kyc.country} />
                        <div className="col-lg-4 col-sm-6 col-12">
                            <h6 className="e-font-14 e-line-height-18 e-montserrat-semi-bold color-gray mb-2">
                                Email
                            </h6>
                            <a href={`mailto:${props.data.overview.email}`} className="e-font-14 e-line-height-18 e-montserrat-medium color-dark-charcoal mb-0 text-decoration-none">
                                {props.data.overview.email === null ? "-" : props.data.overview.email}
                            </a>
                        </div>

                        <div className="col-lg-4 col-sm-6 col-12">
                            <h6 className="e-font-14 e-line-height-18 e-montserrat-semi-bold color-gray mb-2">
                                Phone no
                            </h6>
                            <a href={`tel:${props.data.overview.phone}`} className="e-font-14 e-line-height-18 e-montserrat-medium color-dark-charcoal mb-0 text-decoration-none">
                                {props.data.overview.phone === null ? "-" : props.data.overview.phone}
                            </a>
                        </div>

                        <ProfileInfo title="IIN"
                            description={props.data.overview.iin} />

                        <ProfileInfo title="MF Investment Account ID"
                            description={props.data.overview.mf_investment_account_id} />

                        <ProfileInfo title="Profile ID"
                            description={props.data.overview.profile_id} />


                    </div>
                </div>

                {/* ===================Tax details ================*/}
                <div className="border-bottom-point5px border-color-mint-gray mt-4 pb-4">
                    <h4 className="e-font-16 e-line-height-20 e-montserrat-semi-bold color-gunmetal-gray mb-3">Nationality, tax and source</h4>

                    <div className="row row-gap-24px">
                        <ProfileInfo title="Source of income"
                            description={props.data.overview.wealth_source} />
                        <ProfileInfo title="Annual income"
                            description={props.data.overview.annual_income !== null ? props.data.overview.annual_income.toLocaleString('en-IN') : null} />
                        <ProfileInfo title="Occupation"
                            description={props.data.overview.occupation} />
                    </div>
                </div>

                {/* ===================Communication details ================*/}
                {Object.keys(props.data.kyc.address.permanent_address).length > 0 && <div className="border-bottom-point5px border-color-mint-gray mt-4 pb-4">
                    <h4 className="e-font-16 e-line-height-20 e-montserrat-semi-bold color-gunmetal-gray mb-3">Communication details</h4>

                    <div className="row row-gap-24px">

                        {
                            Object.keys(props.data.kyc.address.permanent_address).length > 0 && <div className="col-lg-12 col-12 ">
                                <h6 className="e-font-14 e-line-height-18 e-montserrat-semi-bold color-gray mb-2">
                                    Permanent address
                                </h6>
                                <p className="e-font-14 e-line-height-18 e-montserrat-medium color-dark-charcoal mb-0">
                                    {props.data.kyc.address.permanent_address.address_line1}  {props.data.kyc.address.permanent_address.address_line2}, {props.data.kyc.address.permanent_address.city} ,  {props.data.kyc.address.permanent_address.state} -  {props.data.kyc.address.permanent_address.pincode}
                                </p>
                            </div>
                        }

                        {
                            Object.keys(props.data.kyc.address.correspondence_address).length > 0 && <div className="col-lg-12 col-12 pt-4">
                                <h6 className="e-font-14 e-line-height-18 e-montserrat-semi-bold color-gray mb-2">
                                    Permanent address
                                </h6>
                                <p className="e-font-14 e-line-height-18 e-montserrat-medium color-dark-charcoal mb-0">
                                    {props.data.kyc.address.correspondence_address.address_line1} , {props.data.kyc.address.correspondence_address.address_line2}, {props.data.kyc.address.correspondence_address.city},  {props.data.kyc.address.correspondence_address.state} -  {props.data.kyc.address.correspondence_address.pincode}
                                </p>
                            </div>
                        }


                    </div>
                </div>}


                {/* ===================Bank details ================*/}
                <div className="mt-4 pb-4 border-bottom-point5px border-color-mint-gray">
                    <div className="row">
                        <div className="col-2">
                            <h4 className="e-font-16 e-line-height-20 e-montserrat-semi-bold color-gunmetal-gray mb-3">Bank details</h4>
                        </div>
                        {
                            props.data.overview?.bank1_status === "FAILED" ?
                                <div className="col-10 text-end d-flex gap-2 justify-content-end">
                                    <TextButton name={downloadLoader ? "Downloading..." : "Download"}
                                        hide_arrow
                                        className={downloadLoader ? "e-pointer-events-none" : ""}
                                        onPress={_downloadForm} />
                                    <TextButton name={uploadLoader ? "Uploading..." : "Upload"}
                                        hide_arrow
                                        className={uploadLoader ? "e-pointer-events-none" : ""}
                                        onPress={_uploadForm} />
                                </div>
                                : null
                        }

                    </div>
                    <div className="row row-gap-24px">
                        <ProfileInfo title="Account number"
                            description={props.data.bank.account} />

                        <ProfileInfo title="Bank name"
                            description={props.data.bank.name} />

                        <ProfileInfo title="Branch"
                            description={props.data.bank.branch} />

                        <ProfileInfo title="IFSC code"
                            description={props.data.bank.ifsc} />

                    </div>
                </div>

                <div className=" mt-4 pb-4">
                    <h4 className="e-font-16 e-line-height-20 e-montserrat-semi-bold color-gunmetal-gray mb-3">NSE KYC status</h4>

                    <div className="row row-gap-24px">
                        <ProfileInfo title="Auth status"
                            description={props.data.overview.auth_status} />
                        <ProfileInfo title="Bank status"
                            description={props.data.overview.bank1_status} />
                        <ProfileInfo title="First holder auth status"
                            description={props.data.overview.first_holder_auth_status} />
                        <ProfileInfo title="Primary holder KYC status"
                            description={props.data.overview.primary_holder_kyc_status} />
                    </div>
                </div>

            </div>
        </Fragment >
    )
}

export default Profile